import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import { gql } from '@/service/gql'
import type { ResultOf } from 'gql.tada'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'

// language=GraphQL
export const podcastEpisodeFieldsFrag = gql(
    `
        fragment podcastEpisodeFields on PodcastEpisode @_unmask {
            ...playableEntity
            id
            title
            author
            description
            duration
            releaseDate
            contentBenefitTypes
            images {
                ...imageFields
            }
            podcast {
                id
                title
            }

            eligibility {
                playbackSubscriptionTiers
                playback {
                    canPlayOnDemand
                    shuffleType
                }
                isDownloadable
            }
            playbackInformation {
                audioUrl
                progressMilliseconds
                completedState
            }
        }
    `,
    [imageFieldsFrag, playableEntityFrag]
)

export type PodcastEpisodeFields = ResultOf<typeof podcastEpisodeFieldsFrag>
